export default "__VITE_ASSET__cec9646d__"